import { CopyButton } from '@skupreme/shared/ui';

/** A code under a title (SKU, ASIN, UPC) with the kit's copy button. */
export function ItemIdentifier({
  label,
  value,
}: {
  label: string;
  value: string;
}) {
  return (
    <span className="sk:flex sk:min-w-0 sk:items-center sk:gap-1 sk:text-xs sk:text-fg-tertiary">
      <span className="sk:shrink-0">{label}</span>
      <span className="sk:truncate sk:text-fg-secondary">{value}</span>
      {/* Overhangs the code's line box, so the button doesn't make its row taller. */}
      <CopyButton value={value} label={`Copy ${label}`} className="sk:-my-1" />
    </span>
  );
}
